module.exports = __webpack_public_path__ + "b68f555c65542ccad5ae0f73be8cc733.png";